import { notificationInitialState, createNotificationController } from '~/utils/notification-controller.mjs';
export function useUserNotifications() {
    const state = useState('user-notifications-v1', notificationInitialState);
    const app = useNuxtApp();
    // All header instances share one controller; SSR holds no module-global user data.
    if (!app._userNotifications)
        app._userNotifications = createNotificationController(() => state.value, (path, options) => $fetch(path, { timeout: 15000, retry: 0, ...options }));
    return { state, ...app._userNotifications };
}
